import Api from "../apiService";

class PaymentSourcesApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/payment_sources`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/payment_sources/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/payment_sources`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/payment_sources/${id}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/payment_sources/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/payment_sources/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }
}

export default new PaymentSourcesApi();
